import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=c8037e84&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=c8037e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8037e84",
  null
  
)

export default component.exports